import { Injectable } from '@angular/core';
import { HybseConfig } from '../../config/hybse.config';


@Injectable()
export class ApiurlsService {

  constructor(public config: HybseConfig) { }

  /* Get Session Key */
  getSessionkeyUrl: string = this.config.apiURL + 'getSessionkey';


  /* User Api Urls */
  createUserAdminUrl: string = this.config.apiURL + 'adminRegister';
  createUserInvestorUrl: string = this.config.apiURL + 'createInvestorByAdmin';
  createUserIssuerUrl: string = this.config.apiURL + 'createIssuerByAdmin';
  adminListUrl: string = this.config.apiURL + 'adminList';
  deleteUserUrl: string = this.config.apiURL + 'deleteUser';
  getUserDataUrl: string = this.config.apiURL + 'userDetailedView';
  updateUserUrl: string = this.config.apiURL + 'updateUser';
  updateAdminUrl: string = this.config.apiURL + 'updateAdmin';
  viewWalletUrl: string = this.config.apiURL + 'userWalletDetails';
  userActiveUrl: string = this.config.apiURL + 'activeUser';
  detailedUserInfo: string = this.config.apiURL + 'detailedUserInfo';
  userLoginDetailsUrl: string = this.config.apiURL + 'userLoginDetails';

  /* stock list */
  demoStockListUrl: string = this.config.apiURL + 'demoStockList';
  stockListUrl: string = this.config.apiURL + 'allStockList';

  /* Login Api Urls */
  loginUrl: string = this.config.authURL + 'adminLogin';


  /*  dashboard */
  getUserOverview = this.config.apiURL + 'getUserOverview';


  /*  User details */
  userDemoBuyorderList = this.config.apiURL + 'userDemoBuyorderList';
  userDemoSellorderList = this.config.apiURL + 'userDemoSellorderList';
  userBuyorderList = this.config.apiURL + 'userBuyorderList';
  userSellorderList = this.config.apiURL + 'userSellorderList';
  demoWalletsDetails = this.config.apiURL + 'userDemoWalletDetails';
  updateUserInfoByAdmin = this.config.apiURL + 'updateUserInfoByAdmin';
  iboSellorderListUrl = this.config.apiURL + 'iboSellorderList';
  iboBuyListUrl = this.config.apiURL + 'iboBuyList';
  iboCommissionListUrl = this.config.apiURL + 'iboCommissionList';


  /* News Api Urls */
  compListUrl: string = this.config.apiURL + 'listExchangeNews';
  newsCreateUrl: string = this.config.apiURL + 'createNews';
  compDetailUrl: string = this.config.apiURL + 'getNews';
  companyUpdateUrl: string = this.config.apiURL + 'editNews';
  companyDeleteUrl: string = this.config.apiURL + 'deleteNews';
  companyActiveUrl: string = this.config.apiURL + 'publishNews';

  /* Voucher API URLs */
  voucherActivateUrl: string = this.config.apiURL + 'activateCouponCode';
  voucherDeactivateUrl: string = this.config.apiURL + 'deactivateCouponCode';
  voucherListUrl: string = this.config.apiURL + 'getCouponList';
  voucherRedeemedUrl: string = this.config.apiURL + 'redeemedVoucher';
  voucherArchiveListUrl: string = this.config.apiURL + 'getArchivedCouponList';
  voucherArchiveUrl: string = this.config.apiURL + 'setArchive';

  /* Voucher Config URLs */
  vconfigCreateUrl: string = this.config.apiURL + 'createVoucherConfig';
  vconfigUpdateUrl: string = this.config.apiURL + 'updateVoucherConfig';
  vconfigListUrl: string = this.config.apiURL + 'getVoucherConfigList';
  vconfigDetailsUrl: string = this.config.apiURL + 'getDetailedVoucherConfig';

  /* Affiliate URLs */
  affiliateCraeteUrl: string = this.config.apiURL + 'createAffiliate';
  affiliateUpdateUrl: string = this.config.apiURL + 'updateAffiliate';
  // affiliateDeleteUrl: string = this.config.apiURL + 'deleteAffiliate';
  affiliateListUrl: string = this.config.apiURL + 'getAffiliateList';
  affiliateDetailUrl: string = this.config.apiURL + 'getDetailedAffiliate';
  affiliateReport: string = this.config.apiURL + 'getAffiliateReport';



  /* Page Category */
  pageCatListUrl: string = this.config.apiURL + 'listContentCategory';
  pageCatCreateUrl: string = this.config.apiURL + 'createContentCategory';
  pageCatUpdateUrl: string = this.config.apiURL + 'updateContentCategory';
  pageCatDeleteUrl: string = this.config.apiURL + 'deleteContentCategory';
  getpageCatUrl: string = this.config.apiURL + 'getContentCategory';

  /* Page  */
  pageListUrl: string = this.config.apiURL + 'listContent';
  pageCreateUrl: string = this.config.apiURL + 'createContent';
  pageUpdateUrl: string = this.config.apiURL + 'updateContent';
  pageDeleteUrl: string = this.config.apiURL + 'deleteContent';
  getpageUrl: string = this.config.apiURL + 'getContent';


  /* Menu  */
  createMenuUrl: string = this.config.apiURL + 'createMenu';
  updateMenuUrl: string = this.config.apiURL + 'updateMenu';
  deleteMenuUrl: string = this.config.apiURL + 'deleteMenu';
  listAllMenuUrl: string = this.config.apiURL + 'listAllMenu';


  /* Menu  Items */
  createMenuItems: string = this.config.apiURL + 'createMenuItems';
  updateMenuItemsUrl: string = this.config.apiURL + 'updateMenuItems';
  deleteMenuItemsUrl: string = this.config.apiURL + 'deleteMenuItems';
  listAllMenuItemUrl: string = this.config.apiURL + 'orderMenuHierarchy';
  listMenuItemUrl: string = this.config.apiURL + 'getMenuItemsByName';


  /* Symbols */
  createSymbolUrl: string = this.config.apiURL + 'createSymbol';
  updateSymbolUrl: string = this.config.apiURL + 'updateSymbol';
  deleteSymbolUrl: string = this.config.apiURL + 'deleteSymbol';
  primarySymbolUrl: string = this.config.apiURL + 'primarySymbol';

  /* Markets */
  createMarketUrl: string = this.config.apiURL + 'createMarket';
  updateMarketUrl: string = this.config.apiURL + 'updateMarket';
  deleteMarketUrl: string = this.config.apiURL + 'deleteMarket';
  marketListUrl: string = this.config.apiURL + 'marketList';
  marketDetailUrl: string = this.config.apiURL + 'detailedMarket';


  /* Activities Log */
  activityLogsUrl: string = this.config.apiURL + 'userActivityDetails';
  activityCodeUrl: string = this.config.apiURL + 'activityCode';
  activityDetailsUrl: string = this.config.apiURL + 'activityDetails';
  commissionLogListUrl = this.config.apiURL + 'commissionLogList';
  orderMatchesListUrl = this.config.apiURL + 'orderMatchesList';

  /* demo Activities log */
  demoCommissionLogListUrl: string = this.config.apiURL + 'demoCommissionLogList';
  demoOrderMatchesListUrl = this.config.apiURL + 'demoOrderMatchesList';


  /* Locale */
  createLocaleUrl: string = this.config.apiURL + 'createLocale';
  updateLocaleUrl: string = this.config.apiURL + 'updateLocale';
  deleteLocaleUrl: string = this.config.apiURL + 'deleteLocale';
  listLocaleUrl: string = this.config.apiURL + 'getLocale';
  getLocaleByIdUrl: string = this.config.apiURL + 'getLocaleone';

  /* Translation */
  createTranslationUrl: string = this.config.apiURL + 'createTranslation';
  updateTranslationUrl: string = this.config.apiURL + 'updateTranslation';
  deleteTranslationUrl: string = this.config.apiURL + 'deleteTranslation';
  listTranslationUrl: string = this.config.apiURL + 'translationList';
  getTranslationByIdUrl: string = this.config.apiURL + 'getTranslationOne';

  /* Mail Template */
  createMessageTemplateUrl: string = this.config.apiURL + 'createMessageTemplate';
  updateMessageTemplateUrl: string = this.config.apiURL + 'updateMessageTemplate';
  deleteMessageTemplateUrl: string = this.config.apiURL + 'deleteMessageTemplate';
  listMessageTemplateUrl: string = this.config.apiURL + 'listMessageTemplate';
  getTemplateByIdUrl: string = this.config.apiURL + 'messageTemplateByIdMessageTemplate';

  /* IBO  */
  createIBOUrl: string = this.config.apiURL + 'createIBOMarket';
  updateIBOUrl: string = this.config.apiURL + 'updateIBOMarket';
  deleteIBOUrl: string = this.config.apiURL + 'deleteIBO';
  listIBOUrl: string = this.config.apiURL + 'iBOList';
  getIBObyIdUrl: string = this.config.apiURL + 'iBODetailedList';

  /* DemoCompany  */
  createDemoCompanyUrl: string = this.config.apiURL + 'createDemoCompany';
  listDemoCompanyUrl: string = this.config.apiURL + 'demoCompanyList';

  /* DemoSymbol  */
  listDemoSymbolUrl: string = this.config.apiURL + 'listDemoSymbol';
  primaryDemoSymbolUrl: string = this.config.apiURL + 'primaryDemoSymbol';

  /* DemoMarket  */
  demoMarketListUrl: string = this.config.apiURL + 'demoMarketList';
  marketDemoDetailUrl: string = this.config.apiURL + 'detailedDemoMarket';

  /* Invitation */
  createInvitationUrl: string = this.config.apiURL + 'inviteUser';
  listInvitationUrl: string = this.config.apiURL + 'invitationList';

  /* KYC */
  KycListUrl: string = this.config.apiURL + 'kycList';
  approveKycUrl: string = this.config.apiURL + 'kycVerify';
  rejectKycUrl: string = this.config.apiURL + 'kycReject';

  /* Partner */
  partnerTradeListUrl: string = this.config.apiURL + 'partnerTradeList';
  partnerTxnLogUrl: string = this.config.apiURL + 'partnerTxnLog';

  /* Log Out Api Urls */
  logOutUrl: string = this.config.apiURL + 'Logout';

  /* NEM Wallet balance */
  nemBalanceUrl: string = this.config.apiURL + 'getNemBalance';

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/services/api-urls/apiurls.service.ts